export class UpdateWorkspaceLoggingSettingsInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateWorkspaceLoggingSettingsInputAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "UpdateWorkspaceLoggingSettingsInputGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceLoggingSettingsInput.attributeTypeMap;
    }
    constructor() {
    }
}
